export const USER_MARKUP = '@[user:__id__|__display__]';

export const PLACEHOLDERS = {
  id: '__id__',
  display: '__display__',
};
